import { gql, useMutation } from '@apollo/client'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { ReCAPTCHA } from 'react-google-recaptcha'
import { environment } from 'constants/environment'

const VERIRY_INVISIBLE_RECAPTCHA = gql`
  mutation verifyInvisibleRecaptcha($token: String!) {
    verifyInvisibleRecaptchaToken(token: $token) {
      isSuccess
    }
  }
`

export const InvisibleRecaptcha = forwardRef((props, ref) => {
  const recaptchaRef = useRef(null)
  const [verifyToken] = useMutation(VERIRY_INVISIBLE_RECAPTCHA)

  useImperativeHandle(ref, () => ({
    execute: async () => {
      if (recaptchaRef && recaptchaRef.current) {
        const token = await recaptchaRef.current.executeAsync()
        const { data: { verifyInvisibleRecaptchaToken } = {}, errors } =
          await verifyToken({
            variables: { token },
          })

        if (errors) {
          return false
        }
        return verifyInvisibleRecaptchaToken.isSuccess
      }
      return false
    },
  }))
  return (
    <div key="invisibleRecaptchaKey">
      {typeof window !== 'undefined' && window?.grecaptcha && (
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          grecaptcha={window.grecaptcha}
          sitekey={environment.G_RECAPTCHA_V2_API_KEY}
        />
      )}
    </div>
  )
})
